const STEPS = Object.freeze({
  BAIXAR_MODELO: 0,
  UPLOAD_ARQUIVO: 1,
  VALIDACAO: 2,
  CONFIGURACAO: 3,
  CONFIRMACAO: 4,
  EM_PROCESSAMENTO: 5,
  FALHA: -1
});

export default STEPS;